import {
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Form, Formik } from "formik";
import { useHistory, useParams } from "react-router";
import LabelsContext from "../../../lang/LabelsContext";
import EnumReviewStatus from "../../../utils/enum/EnumReviewStatus";
import ArticleCard from "../article-card/ArticleCard";
import TabReview from "../article-details/tab-review/TabReview";
import MakeDecisionButton, { MakeDecisionButtonType } from "../make-decision-button/MakeDecisionButton";
import OverrideArticleService, { OverrideArticleServiceType } from "./OverrideArticleService";
import { useStyles } from "./OverrideArticleStyle";

export default function OverrideArticle() {
  const { article, sendMailToReviewer, handleCloseDialog, openDialog, mailSuggestion }: OverrideArticleServiceType =
    OverrideArticleService();
  const classes = useStyles();
  const { Labels } = LabelsContext();

  const history = useHistory();

  const { id }: any = useParams();

  const rightButtons = () => (
    <Grid container spacing={1}>
      <Grid item>
        <Button variant="contained" size="small" onClick={() => history.push(`/reviewerSelection/${id}`)}>
          {Labels.ACTION}
        </Button>
      </Grid>
    </Grid>
  );

  const makeDecisionArray = [
    {
      label: Labels.ACCEPT,
      reviewStatus: EnumReviewStatus.ACCEPTED,
      styleButton: { backgroundColor: "#00FF00" },
    },
    {
      label: Labels.MINOR_REVISION,
      reviewStatus: EnumReviewStatus.MINOR_REVISION,
      styleButton: { backgroundColor: "#FFFF00" },
    },
    {
      label: Labels.MAJOR_REVISION,
      reviewStatus: EnumReviewStatus.MAJOR_REVISION,
      styleButton: { backgroundColor: "#FF7F00" },
    },
    {
      label: Labels.REJECT,
      reviewStatus: EnumReviewStatus.REJECTED,
      styleButton: { backgroundColor: "#FF0000" },
    },
    {
      label: Labels.DIRECT_REJECT,
      reviewStatus: EnumReviewStatus.DIRECT_REJECT,
      styleButton: { backgroundColor: "#FF0000" },
    },
    {
      label: Labels.REJECTED_R0,
      reviewStatus: EnumReviewStatus.REJECTED_R0,
      styleButton: { backgroundColor: "#FF0000" },
    },

    {
      label: Labels.DIRECT_REJECT_R0,
      reviewStatus: EnumReviewStatus.DIRECT_REJECT_R0,
      styleButton: { backgroundColor: "#FF0000" },
    },
    {
      label: Labels.TO_ASSOCIATE_EDITOR,
      reviewStatus: EnumReviewStatus.RETURNED_TO_EDITOR,
    },
    {
      label: Labels.LETTER_TO_THE_EDITOR,
      reviewStatus: EnumReviewStatus.REJECT_AND_RESUBMIT_AS_A_LETTER_TO_THE_EDITOR,
    },
  ] as MakeDecisionButtonType[];

  return (
    <div>
      <Typography variant="h5">{Labels.OVERRIDE}</Typography>
      <Paper className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} spacing={3}>
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <Card className={classes.card}>
                  <Typography variant="h6" className={classes.marginBottom}>
                    {Labels.SELECT_STATUS}
                  </Typography>
                  <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                    {makeDecisionArray.map((button: MakeDecisionButtonType) => {
                      return (
                        <Grid item xs={12} sm={3}>
                          <MakeDecisionButton article={article} buttonProps={button} />
                        </Grid>
                      );
                    })}
                  </Grid>
                </Card>
              </Grid>
              <Grid item spacing={3}>
                <ArticleCard
                  data={article}
                  index={0}
                  rightComponent={rightButtons}
                  showAssociateEditorDecision={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <TabReview editorView={true} articleId={id} />
        <Dialog
          maxWidth={"sm"}
          fullWidth={true}
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{Labels.NEW_EMAIL}</DialogTitle>
          {mailSuggestion && (
            <Formik
              initialValues={{
                mailto: mailSuggestion.to ? mailSuggestion.to : [],
                cc: mailSuggestion.cc ? mailSuggestion.cc : [],
                subject: mailSuggestion.subject ? mailSuggestion.subject : "",
                message: mailSuggestion.message ? mailSuggestion.message : "",
              }}
              onSubmit={(values) => {
                sendMailToReviewer(values);
                handleCloseDialog();
              }}
            >
              {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
                <Form>
                  <DialogContent>
                    <Grid container direction="column">
                      <Grid item>
                        <Autocomplete
                          className={classes.marginBottom2}
                          multiple
                          id="tags-mailto"
                          value={values.mailto}
                          onChange={(event, value) => setFieldValue("mailto", value)}
                          options={[{ title: "exampleTest@gmail.com" }].map((option) => option.title)}
                          freeSolo
                          renderTags={(value: string[], getTagProps) =>
                            value.map((option: string, index: number) => (
                              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                            ))
                          }
                          renderInput={(params) => <TextField {...params} label={Labels.MAILTO} variant="outlined" />}
                        />
                      </Grid>
                      {/* <Grid item>
                        <Autocomplete
                          multiple
                          id="tags-cc"
                          value={values.cc}
                          onChange={(event, value) => setFieldValue("cc", value)}
                          options={[{ title: "exampleTest@gmail.com" }].map((option) => option.title)}
                          freeSolo
                          renderTags={(value: string[], getTagProps) =>
                            value.map((option: string, index: number) => (
                              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                            ))
                          }
                          renderInput={(params) => <TextField {...params} label={Labels.CC} variant="outlined" />}
                        />
                      </Grid> */}
                      <Grid item>
                        <TextField
                          variant="outlined"
                          margin="normal"
                          id="subject"
                          name="subject"
                          label={Labels.SUBJECT}
                          value={values.subject}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.subject && Boolean(errors.subject)}
                          helperText={touched.subject && errors.subject}
                          fullWidth
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          variant="outlined"
                          margin="normal"
                          id="message"
                          name="message"
                          label={Labels.MESSAGE}
                          value={values.message}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.message && Boolean(errors.message)}
                          helperText={touched.message && errors.message}
                          fullWidth
                          multiline
                          rows={6}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                      {Labels.CANCEL}
                    </Button>
                    <Button variant="contained" color="primary" type="submit">
                      {Labels.SEND}
                    </Button>
                  </DialogActions>
                </Form>
              )}
            </Formik>
          )}
        </Dialog>
      </Paper>
    </div>
  );
}
